import { render, staticRenderFns } from "./GiteeGistPublishModal.vue?vue&type=template&id=d4ff1794&"
import script from "./GiteeGistPublishModal.vue?vue&type=script&lang=js&"
export * from "./GiteeGistPublishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteeGistPublishModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteeGistPublishModal.vue
// module id = 2357
// module chunks = 1